import { Component, OnInit, ViewChild } from '@angular/core';
import { IonAccordionGroup, MenuController } from '@ionic/angular';
import { delay } from 'rxjs/operators';

import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from 'src/app/services/routing/navigator';

import { BalanceModel } from 'src/app/models/balance-model';
import { IBalanceMenu } from 'src/app/interfaces/sidemenu-interface';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['balance.component.scss'],
})

export class BalanceComponent implements OnInit {
  @ViewChild('accordionGroup', { static: true }) accordionGroup: IonAccordionGroup;

	public accountBalances: BalanceModel;
  public iconAccordian: string = "chevron-down-outline";
  public showHideBalanceText: string;
  public showmenu: boolean = true;

  public accordianMenu: IBalanceMenu[] = [{
      mode: 'SHOW',
      text: 'Hide Balance',
      icon: 'chevron-up-outline'
    }, {
      mode: 'HIDE',
      text: 'Show Balance',
      icon: 'chevron-down-outline'
    }
  ]

  constructor(
    private balanceService: AccountBalanceService,
    private config: ConfigService,
    private events:EventsService,
    private menuCtrl:MenuController,
    private navigator: Navigator,
  ){
    this.showHideBalanceText = this.accordianMenu[1].text;
  }

  ngOnInit(): void {
    this.events.subscribe('hide:balanceSection',()=> {
      this.closeAccordian();
    })
  }

  public onInfo(){
    this.menuCtrl.close();
    this.navigator.navigateTo('AccountBalanceComponent',{},{},"main-menu");
  }

  public toggleAccordion = (): any => {
    this.updateAccordianValue();

    if(this.showmenu){
      this.balanceService.reloadBalance().subscribe((response: any) => {
        if(!!response.result && response.payload){
          const balanceModel = new BalanceModel(response.payload, this.config.getConfig());
          this.accountBalances = balanceModel;
          this.showHideMenu(0, false);
        }
      }, error => {
        this.getBalance();
        this.showHideMenu(0, false);
      })
      return;
    }

    this.showHideMenu(1, true);
    return;
  }
  
  private showHideMenu(index: number, flag: boolean){
    this.showmenu = flag;
    const value = this.accordianMenu[index];
    this.iconAccordian = value.icon;
    this.showHideBalanceText = value.text;
    return;
  }

  private updateAccordianValue(): any{
    const nativeEl = this.accordionGroup;
    
    if (nativeEl.value === 'balance-accordian') {
      nativeEl.value = undefined;
      return;
    }
    nativeEl.value = 'balance-accordian';
    return;
  }

  private getBalance(): any {
		this.balanceService.getBalance().pipe(delay(300)).subscribe((response: BalanceModel) => {
      this.accountBalances = response;
    });
  }

  private closeAccordian() {
    const nativeEl = this.accordionGroup;
    if (nativeEl.value === 'balance-accordian') {
      nativeEl.value = undefined;
      const value = this.accordianMenu[1]
      this.showmenu = true;
      this.iconAccordian = value.icon;
      this.showHideBalanceText = value.text;
    }
  }
}
